import React from 'react';
import WebApp from '../../utils/WebAppPolyfill';
import { get, postFormData } from '../../network/request';
import './tabView.css';

function normalizeIds(arr) {
    if (!Array.isArray(arr)) return [];
    const nums = arr.map((x) => Number(x)).filter((n) => !Number.isNaN(n));
    return [...new Set(nums)];
}

class RoleTabView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            userRoleType: '1',
            searchQuery: '',
            recommendList: [],
            savedJobIds: [],
            appliedJobIds: [],
            savedTalentIds: [],
            contactedTalentIds: [],
            savedFilter: 'all',
            roleDetail: null,
        };
    }

    async componentDidMount() {
        let selectType = '1';
        const userInfo = localStorage.getItem('initUser');
        let userId = 'test_user_001'; // 默认测试用户
        
        if (userInfo) {
            const parsed = JSON.parse(userInfo);
            selectType = parsed.selectType || '1';
            userId = parsed.user_id || userId;
        }

        this.setState({ userRoleType: selectType });
        
        // 并行加载数据和用户状态
        await Promise.all([
            this.loadRecommendList(selectType),
            this.loadUserJobStatuses(userId),
            this.loadUserTalentStatuses(userId)
        ]);
    }

    // 加载用户职位状态
    async loadUserJobStatuses(userId) {
        try {
            const result = await get('/getUserJobStatuses', { userId });
            if (result.success && result.data) {
                this.setState({
                    savedJobIds: result.data.saved_job_ids || [],
                    appliedJobIds: result.data.applied_job_ids || []
                });
            } else {
                this.setState({ savedJobIds: [], appliedJobIds: [] });
            }
        } catch (error) {
            console.error('Failed to load job statuses:', error);
            this.setState({ savedJobIds: [], appliedJobIds: [] });
        }
    }

    // 加载用户人才状态
    async loadUserTalentStatuses(userId) {
        try {
            const result = await get('/getUserTalentStatuses', { userId });
            if (result.success && result.data) {
                this.setState({
                    savedTalentIds: result.data.saved_talent_ids || [],
                    contactedTalentIds: result.data.contacted_talent_ids || []
                });
            } else {
                this.setState({ savedTalentIds: [], contactedTalentIds: [] });
            }
        } catch (error) {
            console.error('Failed to load talent statuses:', error);
            this.setState({ savedTalentIds: [], contactedTalentIds: [] });
        }
    }

    // 加载推荐列表
    async loadRecommendList(userRoleType) {
        try {
            const isJobSeeker = userRoleType === '1';
            const endpoint = isJobSeeker ? '/getJobList' : '/getTalentList';
            const result = await get(endpoint);

            if (result.success && result.data) {
                // 解析 skills JSON 字符串
                const list = result.data.map(item => ({
                    ...item,
                    skills: typeof item.skills === 'string'
                        ? JSON.parse(item.skills)
                        : (item.skills || [])
                }));
                this.setState({ recommendList: list });
            } else {
                // API 返回失败或无数据，设置为空数组
                this.setState({ recommendList: [] });
            }
        } catch (error) {
            console.error('Failed to load recommend list:', error);
            // API 请求失败，设置为空数组
            this.setState({ recommendList: [] });
        }
    }

    toast = (message) => {
        const text = String(message == null ? '' : message).replace(/\r/g, '').slice(0, 400);
        try {
            if (typeof WebApp?.showAlert === 'function') {
                WebApp.showAlert(text, () => {});
                return;
            }
        } catch (err) {
            console.warn('WebApp.showAlert failed:', err);
        }
        try {
            window.alert(text);
        } catch {
            /* ignore */
        }
    };

    handleSearchChange = (e) => {
        this.setState({ searchQuery: e.target.value });
    };

    setSavedFilter = (savedFilter) => {
        this.setState({ savedFilter });
    };

    getInitials = (name) => {
        return name
            .split(' ')
            .map((n) => n[0])
            .join('')
            .substring(0, 2)
            .toUpperCase();
    };

    openDetail = (item, mode) => {
        this.setState({ roleDetail: { mode, item } });
    };

    closeDetail = () => {
        this.setState({ roleDetail: null });
    };

    handleCardActivate = (e, item, mode) => {
        if (e.target.closest('button')) return;
        this.openDetail(item, mode);
    };

    cardKeyDown = (e, item, mode) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.openDetail(item, mode);
        }
    };

    handleApplyJob = async (e, item) => {
        e?.stopPropagation?.();
        if (!item || item.id == null) return;
        
        const userId = this.getUserId();
        const jobId = Number(item.id);
        
        try {
            const formData = new FormData();
            formData.append('userId', userId);
            formData.append('jobId', String(jobId));
            
            const result = await postFormData('/applyJob', formData);
            if (result.success) {
                const appliedJobIds = [...this.state.appliedJobIds, jobId];
                this.setState({ appliedJobIds });
                const title = String(item.name || 'this role');
                const company = String(item.company || 'the company');
                this.toast(`Applied to "${title}" at ${company} successfully!`);
            } else {
                this.toast(result.message || 'Application failed');
            }
        } catch (error) {
            console.error('Apply job failed:', error);
            this.toast('Application failed, please try again');
        }
    };

    toggleSaveJob = async (e, item) => {
        e?.stopPropagation?.();
        if (!item || item.id == null) return;

        const userId = this.getUserId();
        const jobId = Number(item.id);
        let savedJobIds = normalizeIds(this.state.savedJobIds);
        const idx = savedJobIds.indexOf(jobId);

        try {
            const formData = new FormData();
            formData.append('userId', userId);
            formData.append('jobId', String(jobId));

            if (idx >= 0) {
                // 取消收藏
                const result = await postFormData('/unsaveJob', formData);
                if (result.success) {
                    savedJobIds.splice(idx, 1);
                    this.setState({ savedJobIds });
                }
            } else {
                // 收藏
                const result = await postFormData('/saveJob', formData);
                if (result.success) {
                    savedJobIds.push(jobId);
                    this.setState({ savedJobIds });
                }
            }
        } catch (error) {
            console.error('Toggle save job failed:', error);
        }
    };

    getUserId = () => {
        const userInfo = localStorage.getItem('initUser');
        if (userInfo) {
            try {
                return JSON.parse(userInfo).user_id || 'test_user_001';
            } catch {
                return 'test_user_001';
            }
        }
        return 'test_user_001';
    };

    handleContactTalent = async (e, item) => {
        e?.stopPropagation?.();
        if (!item || item.id == null) return;
        
        const userId = this.getUserId();
        const talentId = Number(item.id);
        const contactedTalentIds = normalizeIds(this.state.contactedTalentIds);
        const already = contactedTalentIds.includes(talentId);
        
        try {
            const note = `Interested in ${item.name} (${item.title}) - ${item.location}.`;
            const formData = new FormData();
            formData.append('userId', userId);
            formData.append('talentId', String(talentId));
            formData.append('note', note);
            
            const result = await postFormData('/contactTalent', formData);
            if (result.success) {
                if (!already) {
                    const next = [...contactedTalentIds, talentId];
                    this.setState({ contactedTalentIds: next });
                }
                this.toast(already ? `Suggested note:\n${note}` : `Marked as contacted. Suggested note:\n${note}`);
            } else {
                this.toast(result.message || 'Contact failed');
            }
        } catch (error) {
            console.error('Contact talent failed:', error);
            this.toast('Contact failed, please try again');
        }
    };

    toggleSaveTalent = async (e, item) => {
        e?.stopPropagation?.();
        if (!item || item.id == null) return;

        const userId = this.getUserId();
        const talentId = Number(item.id);
        let savedTalentIds = normalizeIds(this.state.savedTalentIds);
        const idx = savedTalentIds.indexOf(talentId);

        try {
            const formData = new FormData();
            formData.append('userId', userId);
            formData.append('talentId', String(talentId));

            if (idx >= 0) {
                // 取消收藏
                const result = await postFormData('/unsaveTalent', formData);
                if (result.success) {
                    savedTalentIds.splice(idx, 1);
                    this.setState({ savedTalentIds });
                }
            } else {
                // 收藏
                const result = await postFormData('/saveTalent', formData);
                if (result.success) {
                    savedTalentIds.push(talentId);
                    this.setState({ savedTalentIds });
                }
            }
        } catch (error) {
            console.error('Toggle save talent failed:', error);
        }
    };

    renderRecommendItem = (item) => {
        const isJobSeeker = this.state.userRoleType === '1';
        const savedJob = this.state.savedJobIds.includes(item.id);
        const applied = this.state.appliedJobIds.includes(item.id);
        const savedTalent = this.state.savedTalentIds.includes(item.id);
        const contacted = this.state.contactedTalentIds.includes(item.id);

        if (isJobSeeker) {
            return (
                <div
                    key={item.id}
                    className="recommendItem recommendItemInteractive"
                    onClick={(e) => this.handleCardActivate(e, item, 'job')}
                    onKeyDown={(e) => this.cardKeyDown(e, item, 'job')}
                    role="button"
                    tabIndex={0}
                    aria-label={`${item.name} at ${item.company}, view details`}
                >
                    <div className="recommendAvatar">{item.company.substring(0, 2).toUpperCase()}</div>
                    <div className="recommendInfo">
                        <div className="recommendHeader">
                            <p className="recommendName">{item.name}</p>
                            <span className="recommendType">{item.type}</span>
                        </div>
                        <p className="recommendCompany">{item.company}</p>
                        <div className="recommendMeta">
                            <span className="metaItem">{item.location}</span>
                            <span className="metaSeparator">•</span>
                            <span className="metaItem">{item.salary}</span>
                            <span className="metaSeparator">•</span>
                            <span className="metaItem">{item.experience}</span>
                        </div>
                        <div className="recommendSkills">
                            {item.skills.slice(0, 4).map((skill, idx) => (
                                <span key={idx} className="skillTag">
                                    {skill}
                                </span>
                            ))}
                        </div>
                        <div className="recommendFooter">
                            <span className="postTime">Posted {item.posted}</span>
                            <span className="applicants">{item.applicants} applicants</span>
                        </div>
                    </div>
                    <div className="recommendActions">
                        <button
                            type="button"
                            className={`actionButton primary ${applied ? 'actionButtonDone' : ''}`}
                            onClick={(e) => this.handleApplyJob(e, item)}
                            disabled={applied}
                        >
                            {applied ? 'Applied' : 'Apply'}
                        </button>
                        <button
                            type="button"
                            className={`actionButton secondary ${savedJob ? 'actionButtonSaved' : ''}`}
                            onClick={(e) => this.toggleSaveJob(e, item)}
                        >
                            {savedJob ? 'Saved' : 'Save'}
                        </button>
                    </div>
                </div>
            );
        }

        return (
            <div
                key={item.id}
                className="recommendItem recommendItemInteractive"
                onClick={(e) => this.handleCardActivate(e, item, 'talent')}
                onKeyDown={(e) => this.cardKeyDown(e, item, 'talent')}
                role="button"
                tabIndex={0}
                aria-label={`${item.name}, ${item.title}, view profile`}
            >
                <div className="recommendAvatar">{this.getInitials(item.name)}</div>
                <div className="recommendInfo">
                    <div className="recommendHeader">
                        <p className="recommendName">{item.name}</p>
                        <span className="recommendAvailability">{item.availability}</span>
                    </div>
                    <p className="recommendTitle">{item.title}</p>
                    <div className="recommendMeta">
                        <span className="metaItem">{item.exp} exp</span>
                        <span className="metaSeparator">•</span>
                        <span className="metaItem">{item.location}</span>
                        <span className="metaSeparator">•</span>
                        <span className="metaItem">{item.salary}</span>
                    </div>
                    <div className="recommendSkills">
                        {item.skills.slice(0, 4).map((skill, idx) => (
                            <span key={idx} className="skillTag">
                                {skill}
                            </span>
                        ))}
                    </div>
                    <p className="recommendSummary">{item.summary}</p>
                    <div className="recommendEducation">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="eduIcon" aria-hidden>
                            <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
                            <path d="M6 12v5c3 3 9 3 12 0v-5" />
                        </svg>
                        <span>{item.education}</span>
                    </div>
                </div>
                <div className="recommendActions">
                    <button
                        type="button"
                        className={`actionButton primary ${contacted ? 'actionButtonDone' : ''}`}
                        onClick={(e) => this.handleContactTalent(e, item)}
                    >
                        {contacted ? 'Contacted' : 'Contact'}
                    </button>
                    <button
                        type="button"
                        className={`actionButton secondary ${savedTalent ? 'actionButtonSaved' : ''}`}
                        onClick={(e) => this.toggleSaveTalent(e, item)}
                    >
                        {savedTalent ? 'Shortlisted' : 'Shortlist'}
                    </button>
                </div>
            </div>
        );
    };

    renderDetailOverlay = () => {
        const { roleDetail } = this.state;
        if (!roleDetail) return null;

        const { mode, item } = roleDetail;
        const isJob = mode === 'job';
        const savedJob = isJob && this.state.savedJobIds.includes(item.id);
        const applied = isJob && this.state.appliedJobIds.includes(item.id);
        const savedTalent = !isJob && this.state.savedTalentIds.includes(item.id);
        const contacted = !isJob && this.state.contactedTalentIds.includes(item.id);

        return (
            <div className="roleDetailOverlay" role="dialog" aria-modal="true" aria-labelledby="roleDetailTitle" onClick={this.closeDetail}>
                <div className="roleDetailPanel" onClick={(e) => e.stopPropagation()}>
                    <header className="roleDetailHeader">
                        <button type="button" className="roleDetailBack" onClick={this.closeDetail} aria-label="Close">
                            <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
                                <path d="M18 6L6 18M6 6l12 12" />
                            </svg>
                        </button>
                        <h2 id="roleDetailTitle" className="roleDetailTitle">
                            {item.name}
                        </h2>
                    </header>
                    <div className="roleDetailBody">
                        {isJob ? (
                            <>
                                <p className="roleDetailSubtitle">{item.company}</p>
                                <div className="recommendMeta roleDetailMeta">
                                    <span className="metaItem">{item.location}</span>
                                    <span className="metaSeparator">•</span>
                                    <span className="metaItem">{item.salary}</span>
                                    <span className="metaSeparator">•</span>
                                    <span className="metaItem">{item.type}</span>
                                </div>
                                <div className="recommendSkills">
                                    {item.skills.map((skill, idx) => (
                                        <span key={idx} className="skillTag">
                                            {skill}
                                        </span>
                                    ))}
                                </div>
                                <p className="roleDetailDescription">{item.description}</p>
                                <p className="roleDetailFootnote">
                                    Posted {item.posted} · {item.applicants} applicants · {item.experience}
                                </p>
                            </>
                        ) : (
                            <>
                                <p className="roleDetailSubtitle">{item.title}</p>
                                <div className="recommendMeta roleDetailMeta">
                                    <span className="metaItem">{item.exp} exp</span>
                                    <span className="metaSeparator">•</span>
                                    <span className="metaItem">{item.location}</span>
                                    <span className="metaSeparator">•</span>
                                    <span className="metaItem">{item.salary}</span>
                                </div>
                                <p className="roleDetailBadge">{item.availability}</p>
                                <div className="recommendSkills">
                                    {item.skills.map((skill, idx) => (
                                        <span key={idx} className="skillTag">
                                            {skill}
                                        </span>
                                    ))}
                                </div>
                                <p className="roleDetailDescription">{item.summary}</p>
                                <div className="recommendEducation roleDetailEdu">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="eduIcon" aria-hidden>
                                        <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
                                        <path d="M6 12v5c3 3 9 3 12 0v-5" />
                                    </svg>
                                    <span>{item.education}</span>
                                </div>
                            </>
                        )}
                    </div>
                    <footer className="roleDetailFooter">
                        {isJob ? (
                            <>
                                <button
                                    type="button"
                                    className={`actionButton primary ${applied ? 'actionButtonDone' : ''}`}
                                    onClick={(e) => this.handleApplyJob(e, item)}
                                    disabled={applied}
                                >
                                    {applied ? 'Applied' : 'Apply'}
                                </button>
                                <button
                                    type="button"
                                    className={`actionButton secondary ${savedJob ? 'actionButtonSaved' : ''}`}
                                    onClick={(e) => this.toggleSaveJob(e, item)}
                                >
                                    {savedJob ? 'Saved' : 'Save'}
                                </button>
                            </>
                        ) : (
                            <>
                                <button
                                    type="button"
                                    className={`actionButton primary ${contacted ? 'actionButtonDone' : ''}`}
                                    onClick={(e) => this.handleContactTalent(e, item)}
                                >
                                    {contacted ? 'Contacted' : 'Contact'}
                                </button>
                                <button
                                    type="button"
                                    className={`actionButton secondary ${savedTalent ? 'actionButtonSaved' : ''}`}
                                    onClick={(e) => this.toggleSaveTalent(e, item)}
                                >
                                    {savedTalent ? 'Shortlisted' : 'Shortlist'}
                                </button>
                            </>
                        )}
                    </footer>
                </div>
            </div>
        );
    };

    render() {
        const isJobSeeker = this.state.userRoleType === '1';
        const searchPlaceholder = isJobSeeker ? 'Search jobs, companies, skills, location…' : 'Search candidates, skills, location…';

        const searchedList = this.state.recommendList.filter((item) => {
            const query = this.state.searchQuery.toLowerCase().trim();
            if (!query) return true;
            if (isJobSeeker) {
                const skillsStr = (item.skills || []).join(' ').toLowerCase();
                return (
                    item.name.toLowerCase().includes(query) ||
                    item.company.toLowerCase().includes(query) ||
                    item.location.toLowerCase().includes(query) ||
                    skillsStr.includes(query)
                );
            }
            const skillsStr = Array.isArray(item.skills) ? item.skills.join(' ').toLowerCase() : String(item.skills || '').toLowerCase();
            return (
                item.name.toLowerCase().includes(query) ||
                item.title.toLowerCase().includes(query) ||
                item.location.toLowerCase().includes(query) ||
                skillsStr.includes(query)
            );
        });

        const savedIds = isJobSeeker ? this.state.savedJobIds : this.state.savedTalentIds;
        const visibleList =
            this.state.savedFilter === 'saved' ? searchedList.filter((item) => savedIds.includes(item.id)) : searchedList;

        const sectionLabel = isJobSeeker ? 'Recommended Jobs' : 'Recommended Candidates';
        const savedCount = savedIds.length;

        return (
            <div className={`mineContainer${isJobSeeker ? '' : ' roleTabTalentRoot'}`}>
                <div className="roleSearchContainer">
                    <div className={`searchBarShell ${this.state.searchQuery ? 'searchBarShellActive' : ''}`}>
                        <div className={`searchInputWrapper ${this.state.searchQuery ? 'hasValue' : ''}`}>
                            <span className="searchIconWrap" aria-hidden>
                                <svg className="searchIcon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <circle cx="11" cy="11" r="8" />
                                    <path d="M21 21l-4.35-4.35" />
                                </svg>
                            </span>
                            <input
                                type="search"
                                enterKeyHint="search"
                                className="searchInput"
                                placeholder={searchPlaceholder}
                                value={this.state.searchQuery}
                                onChange={this.handleSearchChange}
                                autoComplete="off"
                                autoCorrect="off"
                                spellCheck="false"
                            />
                            {this.state.searchQuery ? (
                                <button
                                    type="button"
                                    className="searchClearBtn"
                                    onClick={() => this.setState({ searchQuery: '' })}
                                    aria-label="Clear search"
                                >
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
                                        <path d="M18 6L6 18M6 6l12 12" />
                                    </svg>
                                </button>
                            ) : null}
                        </div>
                    </div>

                    <div className="roleFilterChips" role="tablist" aria-label="List filter">
                        <button
                            type="button"
                            role="tab"
                            aria-selected={this.state.savedFilter === 'all'}
                            className={`roleFilterChip ${this.state.savedFilter === 'all' ? 'active' : ''}`}
                            onClick={() => this.setSavedFilter('all')}
                        >
                            All
                        </button>
                        <button
                            type="button"
                            role="tab"
                            aria-selected={this.state.savedFilter === 'saved'}
                            className={`roleFilterChip ${this.state.savedFilter === 'saved' ? 'active' : ''}`}
                            onClick={() => this.setSavedFilter('saved')}
                        >
                            {isJobSeeker ? 'Saved jobs' : 'Shortlisted'}
                            {savedCount > 0 ? <span className="roleFilterChipCount">{savedCount}</span> : null}
                        </button>
                    </div>
                </div>

                <div className="recommendList">
                    <p className="sectionTitle">
                        {sectionLabel}
                        <span className="sectionTitleCount">{visibleList.length}</span>
                    </p>
                    {visibleList.length > 0 ? (
                        visibleList.map((item) => this.renderRecommendItem(item))
                    ) : (
                        <div className="roleEmptyState">
                            <p className="emptyTitle">
                                {this.state.savedFilter === 'saved' ? 'Nothing saved yet' : 'No results'}
                            </p>
                            <p className="emptySubTitle">
                                {this.state.savedFilter === 'saved'
                                    ? isJobSeeker
                                        ? 'Save jobs to find them quickly here.'
                                        : 'Shortlist candidates you want to revisit.'
                                    : 'Try different keywords or clear the search.'}
                            </p>
                            {this.state.savedFilter === 'all' && this.state.searchQuery ? (
                                <button type="button" className="roleEmptyBtn" onClick={() => this.setState({ searchQuery: '' })}>
                                    Clear search
                                </button>
                            ) : null}
                        </div>
                    )}
                </div>

                {this.renderDetailOverlay()}
            </div>
        );
    }
}

export default RoleTabView;
